import React, { Component } from "react";
import styled from "styled-components";
import { Caption, withPanelStyle } from "@appcues/component-library";
import PublishStatusTag from "components/Common/PublishStatusTag";
import Card from "components/Common/Card";
import { getFlowActionsDropdownItems } from "helpers/view";
import { getContentTypeFromStep } from "helpers/steps";

export class StepCardItem extends Component {
  onClickCardItem = () => {
    const { onClickFlowItem, step } = this.props;
    onClickFlowItem(step);
  };

  render() {
    const {
      className,
      createdDate,
      updatedDate,
      step,
      onSelectDropdownOption,
      renderItemIcon
    } = this.props;

    const dropdownOptions = getFlowActionsDropdownItems(
      getContentTypeFromStep(step),
      step.id,
      step.state
    );

    return (
      <Card
        className={`${className} step-card`}
        header={step && step.name ? step.name : "Untitled Flow"}
        dropdownOptions={dropdownOptions}
        onClick={this.onClickCardItem}
        onSelectDropdownOption={onSelectDropdownOption}
      >
        <div className="step-image-container">
          {renderItemIcon({
            step,
            stepImageHeight: "130px",
            isStepCard: true
          })}
        </div>
        <div className="step-card-bottom">
          <div className="step-meta-data">
            <Caption type="tertiary">Created {createdDate}</Caption>
            <Caption type="tertiary">
              Updated {updatedDate || createdDate}
            </Caption>
          </div>

          <div className="step-status">
            <PublishStatusTag published={step.published} state={step.state} />
          </div>
        </div>
      </Card>
    );
  }
}

const StyledStepCardItem = withPanelStyle(styled(StepCardItem)`
  &.step-card {
    display: flex;
    flex-direction: column;

    width: calc(100% - 1rem);
    height: calc(100% - 1rem);
    margin: 0 1rem 1rem 0;
    padding: 1rem;

    main {
      width: 100%;
      flex-grow: 1;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;

      > div {
        width: 100%;
        display: flex;
        justify-content: space-between;
      }
    }

    .step-image-container {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-grow: 1;

      width: calc(100% + 2rem);
      margin-left: -1rem;
      margin-right: -1rem;

      background-color: #d6dbe7;

      img {
        max-width: 100%;
        max-height: 100%;
      }
    }

    .step-card-bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;

      padding: 13px 0;

      margin-bottom: -1rem;

      .step-meta-data {
        margin: 0;

        .step-user-data {
          margin: 0 2px 2px 0;
          font-size: 13px;
          color: ${props => props.theme["$gray-50"]};
        }
      }
    }

    .metadata-item:before,
    .metadata-item + .metadata-item:before {
      display: none;
    }
  }
`);
StyledStepCardItem.displayName = "StepCardItem";

export default StyledStepCardItem;
